module.exports = __webpack_public_path__ + "static/media/icon_miniarrow_red.296c7a01.svg";